import request from '@/utils/http.js';
import env from '../env';

// 获取文件列表
const getFileDownloadList = (params = {}) => {
  let url = '/v3/interacts/data-download/data-download-list';
  return request({
    url: url,
    method: 'POST',
    data: params
  });
};

const checkDownload = (params = {}) => {
  let url = '/v3/interacts/data-download/check-download';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

// 观看端 下载
const download = (params = {}) => {
  let url = '/v3/interacts/data-download/download';
  return request({
    url: url,
    method: 'GET',
    data: params
  });
};

const downloadListJson = params => {
  return request({
    url: params.url,
    method: 'GET',
    params: params
  });
};

export default {
  getFileDownloadList,
  checkDownload,
  download,
  downloadListJson
};

